<template>
  <div>
    <Popover as="div" id="desktop-menu" class="relative inline-block text-left">
      <div>
        <PopoverButton
          class="group inline-flex items-center justify-center text-sm font-medium text-gray-700 hover:text-gray-900"
        >
          <span>{{ $t(cleanFilterName) }}</span>
          <span
            v-if="selectedOptions.length > 0"
            class="ml-1.5 rounded-sm py-0.5 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums"
          >
            {{ selectedOptions.length }}
          </span>
          <ChevronDownIcon
            class="shrink-0 -mr-1 ml-1 h-5 w-5 text-gray-400 group-hover:text-gray-500"
            aria-hidden="true"
          />
        </PopoverButton>
      </div>

      <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <PopoverPanel
          v-contain-in-viewport
          class="origin-top-right absolute right-0 mt-2 bg-white rounded-md shadow-2xl p-4 ring-1 ring-black/5 focus:outline-hidden z-10 max-h-56 overflow-y-scroll overflow-x-hidden"
        >
          <div class="flex rounded-md shadow-xs mb-2 max-w-full" v-if="availableOptions.length > 8">
            <div class="relative grow focus-within:z-10">
              <div class="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                <SearchIcon class="h-3 w-3 text-gray-400" aria-hidden="true" />
              </div>
              <input
                type="text"
                :name="`search-mobile-filter-${filterIdx}`"
                :id="`search-mobile-filter-${filterIdx}`"
                class="focus:ring-primary focus:border-primary block w-full rounded-none pl-10 sm:hidden border-gray-300"
                :placeholder="this.$t(`Search ${filterName.toLowerCase()}`)"
                @input="debounceSearch"
              />
              <input
                type="text"
                :name="`search-desktop-filter-${filterIdx}`"
                :id="`search-desktop-filter-${filterIdx}`"
                class="hidden focus:ring-primary focus:border-primary w-full rounded-none pl-6 sm:block sm:text-xs border-gray-300 py-1"
                :placeholder="this.$t(`Search ${filterName.toLowerCase()}`)"
                @input="debounceSearch"
              />
            </div>
          </div>
          <div v-for="(option, optionIdx) in filteredOptions" :key="option" class="flex items-center max-w-full">
            <input
              :id="`filter-${filterIdx}-${optionIdx}`"
              type="checkbox"
              class="h-4 w-4 border-gray-300 rounded-sm text-primary-dark focus:ring-primary"
              :value="option"
              v-model="selectedOptions"
            />
            <label
              :for="`filter-${filterIdx}-${optionIdx}`"
              class="ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap"
            >
              {{ $t(`${option}`) }}
            </label>
          </div>
          <div
            class="text-center mt-2 cursor-pointer inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-xs text-xs font-medium rounded-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            v-if="selectedOptions.length > 0"
            @click="clear"
          >
            {{ $t("Clear") }}
          </div>
        </PopoverPanel>
      </transition>
    </Popover>
  </div>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { SearchIcon } from "@heroicons/vue/outline";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import { camelCaseToWords, capitalizeFirstLetter } from "@/utils/utils.js";
import { containInViewport } from "@estaly/ui";

export default {
  directives: {
    containInViewport,
  },
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    SearchIcon,
    ChevronDownIcon,
  },
  props: {
    filterName: {
      required: true,
      type: String,
    },
    filterIdx: {
      required: true,
      type: Number,
    },
    currentPage: {
      required: false,
      type: Number,
    },
    availableFilters: {
      type: Object,
      required: true,
    },
    selectedFilters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openFilters: false,
      searchKeyword: "",
      debounce: null,
    };
  },
  computed: {
    selectedOptions: {
      get() {
        return this.selectedFilters[this.filterName];
      },
      set(options) {
        this.$emit("updateFilterSearch", this.filterName, options);
      },
    },
    availableOptions: function () {
      return this.availableFilters[this.filterName];
    },
    filteredOptions: function () {
      if (this.searchKeyword === "") {
        return this.availableOptions;
      }
      return this.availableOptions.filter((option) => {
        return option.toLowerCase().includes(this.searchKeyword.toLowerCase());
      });
    },
    cleanFilterName() {
      return capitalizeFirstLetter(camelCaseToWords(this.filterName));
    },
  },
  methods: {
    debounceSearch: function (event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchKeyword = event.target.value;
      }, 500);
    },
    clear: function () {
      this.$emit("updateFilterSearch", this.filterName, []);
    },
  },
};
</script>
